import React, { useState } from 'react'
import { Card, CardBody, CardHeader, FbButton, FbTab, FbTabs, GridContainer, GridItem } from '@fabricks/ui-components'
import { FuelLevelTenantSetting } from './Settings/FuelLevelTenantSetting'
import { EffCalcTenantSetting } from './Settings/EffCalcTenantSetting'
import { StorageLocationTenantSetting } from './Settings/StorageLocationTenantSetting'
import { UserSettings } from './Settings/UserSettings'
import Dropzone from "react-dropzone";
import getEnvVars from "../environment/environment";
import { UploadDropzone } from "./Dropzone/Dropzone";
import { useImportMaterialsMutation, useImportPackageTypesMutation } from "../api/models";
import Swal from "sweetalert2";
import { get as _get } from 'lodash'
import { showError, showSuccess, showWarn } from "../utils/sweetAlertHelper";
import { createBaseContext } from "../services/apiService";
import { useKeycloak } from "react-keycloak";

export const Settings: React.FC = () => {
    const [keycloak] = useKeycloak()
    const [activeTab, setActiveTab] = useState(0)
    const [importMaterialsRequest] = useImportMaterialsMutation()
    const [importPackageTypesRequest] = useImportPackageTypesMutation()


    const renderTab = (): JSX.Element | null => {
        switch (activeTab) {
            case 0:
                return <FuelLevelTenantSetting />
            case 1:
                return <EffCalcTenantSetting />
            case 2:
                return <StorageLocationTenantSetting />
            default: {
                return null
            }
        }
    }

    const onImportMaterialsHandler = () => {
        if (!keycloak.token) {
            return
        }
        const params = createBaseContext(keycloak.token)
        // @ts-ignore
        importMaterialsRequest(params).then((response: any) => {
            if (_get(response, "data.importMaterials.success", false)) {
                return showSuccess("The import was successfully triggered", "Success")
            }

            if (_get(response, "data.importMaterials.error", false)) {
               return showWarn(_get(response, "data.importMaterials.error.message", ""), `Warning (${_get(response, "data.importMaterials.error.code", "")})`)
            }

            return showError("The import could not be triggered. Please verify the file is in Azure", "")
        })
    }

    const onPackageTypeImportHandler = () => {
        if (!keycloak.token) {
            return
        }

        const params = createBaseContext(keycloak.token)
        // @ts-ignore
        importPackageTypesRequest(params).then((response: any) => {
            if (_get(response, "data.importPackageTypes.success", false)) {
                return showSuccess("The import was successfully triggered", "Success")
            }

            if (_get(response, "data.importPackageTypes.error", false)) {
                return showWarn(_get(response, "data.importPackageTypes.error.message", ""), `Warning (${_get(response, "data.importPackageTypes.error.code", "")})`)
            }

            return showError("The import could not be triggered. Please verify the file is in Azure", "Error")
        })
    }

    return (
        <GridContainer>
            <GridItem md={6} xs={12} sm={12}>
                <UserSettings />
            </GridItem>
            <GridItem md={6} xs={12} sm={12}>
                <Card className="card">
                    <CardHeader className="coloredHeader" color="primary" isStats={false} type="generic">
                        <FbTabs centered activeTabIndex={activeTab} didChangeTab={setActiveTab}>
                            <FbTab label="Filling Level" value={0} />
                            <FbTab label="Storage Efficiency" value={1} />
                            <FbTab label="Storage Location" value={2} />
                        </FbTabs>
                    </CardHeader>
                    <CardBody align="center" isProfile>
                        {renderTab()}
                    </CardBody>
                </Card>
            </GridItem>
            <GridItem md={4} xs={12} sm={12}>
                <Card className="card">
                    <CardHeader className="coloredHeader" color="primary" isStats={false} type="generic">
                        <FbTabs centered activeTabIndex={0} didChangeTab={() => {}}>
                            <FbTab label="Materials" value={0} />
                        </FbTabs>
                    </CardHeader>
                    <CardBody align="center" isProfile>
                        <UploadDropzone url={getEnvVars.calcService.uploads.materials} accept={['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']} />
                        <hr />
                        <FbButton variant={"contained"} onClick={onImportMaterialsHandler} fullWidth={true}>Import from SAP</FbButton>
                    </CardBody>
                </Card>
            </GridItem>
            <GridItem md={4} xs={12} sm={12}>
                <Card className="card">
                    <CardHeader className="coloredHeader" color="primary" isStats={false} type="generic">
                        <FbTabs centered activeTabIndex={0} didChangeTab={() => {}}>
                            <FbTab label="Package Types" value={0} />
                        </FbTabs>
                    </CardHeader>
                    <CardBody align="center" isProfile>
                        <UploadDropzone url={getEnvVars.calcService.uploads.packageTypes} accept={'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'} />
                        <hr />
                        <FbButton variant={"contained"} onClick={onPackageTypeImportHandler} fullWidth={true}>Import from SAP</FbButton>
                    </CardBody>
                </Card>
            </GridItem>
            <GridItem md={4} xs={12} sm={12}>
                <Card className="card">
                    <CardHeader className="coloredHeader" color="primary" isStats={false} type="generic">
                        <FbTabs centered activeTabIndex={0} didChangeTab={() => {}}>
                            <FbTab label="Storage Structure Import" value={0} />
                        </FbTabs>
                    </CardHeader>
                    <CardBody align="center" isProfile>
                        <UploadDropzone url={getEnvVars.calcService.uploads.storage_structure} accept={'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'} />
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
    )
}
